import React, { Component, Fragment, useEffect, useState } from 'react';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import styled from 'styled-components';
import { compose, Mutation, withApollo } from 'react-apollo';
import { Link, withRouter } from 'react-router-dom';
import { withToastManager } from 'react-toast-notifications';
import moment from 'moment-timezone';
import { loadStripe } from '@stripe/stripe-js';

import ConfirmModal from '../components/ConfirmModal';
import { SchedulePaymentUnregistered } from './SchedulePayment';
import { Steps, Step, Wizard } from 'react-albus';

import {
  APPOINTMENTS,
  BOOK_APPT,
  CURRENT_USER,
  ADD_INSURANCE,
  ASSIGN_INSURANCE_TO_APPOINTMENT,
  UPCOMING_APPOINTMENTS,
  SIGNUP,
  UPDATE_ATHENA_CARD,
  ATHENA_CARD,
  SEND_INSURANCE,
  GET_ANALYTICS_ID,
  MEMBERSHIP_CREATE_SESSION,
  QUADPAY_SUBSCRIBED,
  GET_REGION_ELIGIBILITY,
} from '../graphql';
import FullLayout from '../components/FullLayout';
import withAnalytics from '../lib/withAnalytics';
import PickInsuranceProvider from './scheduleDoctor2/index';
import { PickDoctorNewPatient } from './scheduleDoctor2/pickDoctor';
import { InsuranceBenefitsCheckUnregistered } from './scheduleDoctor2/insuranceBenefitsCheck';
import { Stepper } from './scheduleDoctor/stepper';
import Complete from './scheduleDoctor/complete';
import Logo from '../static/palomaTransparent.png';
import ByAKit from './scheduleDoctor/newPatientOnly/buyAKit';
import NoServiceState from './scheduleDoctor/noServiceState';
import { getRegionByAbbreviation, getRegionByName, RegionSelectNotForm } from '../components/RegionSelect';
import Basic from './registration/Basic';
import Profile from './registration/Profile';
import Extended from './registration/Extended';
import SpinLoader from '../components/SpinLoader';
import SelectMembership from './scheduleDoctor2/selectMembership';
import SelectPlan from './scheduleDoctor2/SelectPlan2';
import { isMobile } from 'react-device-detect';
import { isToggleActive } from '../components/featureToggle/toggles';
import UploadInsuranceCard from './scheduleDoctor2/UploadInsuranceCardNew';
import QuadpayComplete from './scheduleDoctor2/QuadpayComplete';
import Otp from './registration/Otp';
import PreferredPronouns from './registration/PreferredPronouns';
import GenderIdentity from './registration/GenderIdentity';
import LegalSex from './registration/LegalSex';
import BirthSex from './registration/BirthSex';
import { uuidv4 } from '../utils/uuid';
import { getMemberVisitPrice, getMemberVisitPriceNumber } from '../utils/pricing';
import { withCookies } from 'react-cookie';
import { Constants } from '../utils/constants';
import BridgeInsurance from './scheduleDoctor2/BridgeInsurance';
import PayersDropDown from '../components/bridge/PayersDropDown';
import { AnimateHit, BridgeEligible, BridgeIneligible, RUN_BRIDGE_SOFT_ELIGIBILITY } from '../components/bridge/softEligibilityForm';

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  padding-top: 40px;
  @media screen and (max-width: 52em) {
    padding-left: 8px;
    padding-right: 8px;
  }
`;

const InnerContainer = styled(Flex)`
  max-width: 850px;
  margin: 0 auto;
  flex-direction: column;
`;

const BridgeScheduleNewPatient2WithProps = ({ match, client }, props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [department, setDepartment] = useState();
  const [currentState, setCurrentState] = useState('STATE');
  const [patientState, setPatientState] = useState(null);
  const [selectedPayer, setSelectedPayer] = useState();

  useEffect(() => {
    if (match && match.params && match.params.state) {
      const dept = getRegionByName(match.params.state);
      setPatientState(dept.value);
    }
  }, []);

  useEffect(
    () => {
      if (patientState) {
        checkStateEligibility();
      }
    },
    [patientState]
  );

  const checkStateEligibility = async () => {
    if (!patientState) return;

    setIsLoading(true);

    try {
      const stateEligibility = await client.query({
        query: GET_REGION_ELIGIBILITY,
        variables: {
          state: patientState,
        },
      });

      setIsLoading(false);

      if (
        !stateEligibility ||
        !stateEligibility.data ||
        !stateEligibility.data.getRegionEligibility ||
        (stateEligibility.data.getRegionEligibility !== 'full' && stateEligibility.data.getRegionEligibility !== 'visit')
      ) {
        setCurrentState('NO_SERVICE');
      } else {
        setCurrentState('INSURANCE_TYPE');
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  if (currentState === 'STATE') {
    return (
      <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
          <Heading textAlign="center" mb={4}>
            In which state are you located?
          </Heading>
          <div
            style={{
              maxWidth: '500px',
              alignSelf: 'center',
              width: '100%',
            }}
          >
            <RegionSelectNotForm
              value={department}
              style={{ width: '100%' }}
              onSelectionChange={(val) => {
                setDepartment(val);
              }}
            />
          </div>
          <Button
            onClick={() => {
              setPatientState(department);
            }}
            mt={4}
            variant={'primary'}
            disabled={!department || !!isLoading}
          >
            {!!isLoading ? 'Checking state...' : 'Continue'}
          </Button>
        </Flex>
      </Flex>
    );
  }

  if (currentState === 'INSURANCE_TYPE') {
    return (
      <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '500px' }}>
          <Heading textAlign="center" mb={4}>
            What type of insurance do you have?
          </Heading>
          <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '300px' }}>
            <Button
              onClick={() => {
                setCurrentState('INELIGIBLE');
              }}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>Medicare / Medicaid / Tricare</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setCurrentState('INELIGIBLE');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>HMO</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setCurrentState('PICK_INSURANCE');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>PPO / EPO</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setCurrentState('I_DONT_KNOW');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>I don't know</Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  }

  if (currentState === 'INSURANCE_MEDICARE') {
    return (
      <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '500px' }}>
          <Heading textAlign="center" mb={3}>
            Do you have a medicare advantage plan?
          </Heading>
          <Text textAlign={'center'}>(Your card will usually show a private insurer like Aetna, Humana, UnitedHealthcare...)</Text>
          <Flex flexDirection={'column'} style={{ maxWidth: '300px' }}>
            <Button
              onClick={() => {
                setCurrentState('INELIGIBLE');
                // setCurrentState('PICK_INSURANCE');
              }}
              mt={4}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>Yes</Text>
              </Flex>
            </Button>
            <Button
              onClick={() => {
                setCurrentState('INELIGIBLE');
              }}
              mt={2}
              variant={'outline'}
            >
              <Flex alignItems={'center'}>
                <Box style={{ height: '12px', width: '12px', borderRadius: '12px', border: '1px solid #344f79' }} mr={3} />
                <Text>NO</Text>
              </Flex>
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  }
  if (currentState === 'PICK_INSURANCE') {
    return (
      <Mutation
        mutation={RUN_BRIDGE_SOFT_ELIGIBILITY}
        onCompleted={(e) => {
          setCurrentState(e.runBridgeSoftEligibility.status);
        }}
      >
        {(runSoftEligibility, { loading: loadingSoft, error: errorSoft, data: dataSoft }) => {
          return (
            <Flex mb={4} flexDirection="column" justifyContent={'center'} alignItems={'center'} p={3}>
              <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" style={{ maxWidth: '500px' }}>
                <Heading textAlign="center" mb={4}>
                  Pick Your Insurance Provider
                </Heading>
                <Text textAlign="center" mb={4} fontSize="18px">
                  What insurance do you plan on using?
                </Text>
              </Flex>
              <div style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
                <PayersDropDown
                  selectedPayer={selectedPayer}
                  onPayerChange={(pyr) => {
                    setSelectedPayer(pyr);
                  }}
                />
              </div>
              <Text textAlign="left" mb={4} fontSize="14px" fontWeight={200} color="#7c7c7c" style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
                e.g. Aetna, United Healthcare
              </Text>
              <Button
                variant="pink"
                width={'fit-content'}
                type="submit"
                disabled={!selectedPayer || !!loadingSoft}
                onClick={() => {
                  runSoftEligibility({
                    variables: {
                      state: patientState,
                      payerId: selectedPayer.bridgeId,
                    },
                  });
                }}
              >
                {!!loadingSoft ? 'Checking...' : 'Check'}
              </Button>

              <Button variant={'outline'} onContinue={()=>props.history.push('/prequalification')}>
                Continue without insurance
              </Button>
            </Flex>
          );
        }}
      </Mutation>
    );
  } else if (currentState === 'ELIGIBLE') {
    return (
      <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} p={3}>
        <BridgeEligible />
        <Link style={{ marginTop: '24px' }} to={`http://localhost:3000/prequalification`} target="_top">
          <Button variant={'primary'}>Schedule</Button>
        </Link>
      </Flex>
    );
  } else if (currentState === 'INELIGIBLE') {
    return (
      <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} p={3}>
        <BridgeIneligible state={getRegionByAbbreviation(patientState).label} />
        <Link style={{ marginTop: '24px' }} to={`/book-appointment-legacy/${getRegionByAbbreviation(patientState).label}`} target="_top">
          <Button variant={'primary'}>Continue without insurance</Button>
        </Link>
      </Flex>
    );
  } else if (currentState === 'NO_SERVICE') {
    return (
      <Flex alignItems={'center'} justifyContent={'center'} p={3}>
        <Flex flexDirection={'column'} style={{ maxWidth: '500px' }}>
          <AnimateHit style={{ alignSelf: 'center' }} className="animable">
            <svg width="120" height="120" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M11.92 55.9999H52.08C56.1867 55.9999 58.7467 51.5466 56.6933 47.9999L36.6133 13.3066C34.56 9.75994 29.44 9.75994 27.3867 13.3066L7.30666 47.9999C5.25333 51.5466 7.81333 55.9999 11.92 55.9999ZM32 37.3333C30.5333 37.3333 29.3333 36.1333 29.3333 34.6666V29.3333C29.3333 27.8666 30.5333 26.6666 32 26.6666C33.4667 26.6666 34.6667 27.8666 34.6667 29.3333V34.6666C34.6667 36.1333 33.4667 37.3333 32 37.3333ZM34.6667 47.9999H29.3333V42.6666H34.6667V47.9999Z"
                fill="rgb(255, 148, 17)"
              />
            </svg>
          </AnimateHit>

          <Text mt={3} textAlign={'center'} fontWeight={300}>
            Sorry
          </Text>

          <Text mt={3} textAlign={'center'} fontWeight={500}>
            Unfortunately Paloma doctors do not service {patientState ? getRegionByAbbreviation(patientState).label : 'your state'} currently. But we have some other Thyroid products for you!
          </Text>

          <Text mt={3} textAlign={'center'} fontWeight={300}>
            Including a complete at-home thyroid test test kits that includes Free T3 and Reverse T3
          </Text>

          <Link style={{ marginTop: '24px', alignSelf: 'center' }} to={`/purchase-kit`} target="_top">
            <Button variant={'primary'}>Test my thyroid</Button>
          </Link>
        </Flex>
      </Flex>
    );
  } else if (currentState === 'I_DONT_KNOW') {
    return (
      <Flex alignItems={'center'} justifyContent={'center'} p={3}>
        <Flex flexDirection={'column'} style={{ maxWidth: '500px' }}>
          <Text mt={3} textAlign={'center'} fontWeight={500}>
            Email us your insurance card, and our support team will get back to you promptly to confirm if your insurance is accepted.
          </Text>

          <a
            style={{ marginTop: '24px', alignSelf: 'center' }}
            href={`mailto:insurance@palomahealth.com?subject=${encodeURIComponent(`Here is my insurance in ${getRegionByAbbreviation(patientState).label}`)}`}
            target="_top"
          >
            <Button variant={'primary'}>Continue</Button>
          </a>
        </Flex>
      </Flex>
    );
  }
};

const BridgeScheduleNewPatient2 = ({history}, props) => {
  useEffect(()=>{
    history.push('/prequalification')
  }, [])
  return (
    <Container>
      <InnerContainer>
        <Card>
          <BridgeScheduleNewPatient2WithProps {...props} />
        </Card>
      </InnerContainer>
      <FullLayout />
    </Container>
  );
};

export default compose(
  withCookies,
  withRouter,
  withApollo,
  withToastManager,
  withAnalytics
)(BridgeScheduleNewPatient2);
